<script>
    import Bar from "./Bar.svelte";
    import {eventBridge, loginTokens, portalConfiguration, csAvailableSupported} from "../../stores.js";
    import {onMount} from "svelte";
    import {derived} from "svelte/store";

    const MSGKEY_CS_INACTIVE = "MSGKEY_CS_INACTIVE";
    const MSGKEY_CS_VERSION = "MSGKEY_CS_VERSION";
    const MSGKEY_CS_GENERIC_ERROR = "MSGKEY_CS_GENERIC_ERROR";
    const MSGKEY_CS_NO_TOKEN = 'MSGKEY_CS_NO_TOKEN';
    const MSGKEY_BEA_LOGGED_OUT = "MSGKEY_BEA_LOGGED_OUT";

    const MSGKEY_INFO_MESSAGE = "MSGKEY_INFO_MESSAGE";
    const MSGKEY_AVAILABILITY_MESSAGE = "MSGKEY_AVAILABILITY_MESSAGE";

    const MSGKEY_KC_MESSAGE = 'KC_MESSAGE';

    const availabilityMessages = derived(eventBridge, ($eventBridge, set) => {
        function handleAvailabilityEvent(event) {
            if (event.detail?.messages) {
                set(event.detail.messages);
            }
        }

        $eventBridge?.addEventListener('portal:availability', handleAvailabilityEvent);

        return () => {
            $eventBridge?.removeEventListener('portal:availability', handleAvailabilityEvent);
        };
    }, []);

    let messageBar;
    let operationsBar;
    let availabilityBar;

    $: if ($portalConfiguration && operationsBar) {
        if ($portalConfiguration.banner) {
            operationsBar.addMessage(MSGKEY_INFO_MESSAGE, $portalConfiguration.banner);
        } else {
            operationsBar.removeMessage(MSGKEY_INFO_MESSAGE);
        }
    }

    $: if ($portalConfiguration && $availabilityMessages && availabilityBar) {
        availabilityBar.clearMessages();

        for (let [i, msg] of $availabilityMessages.entries()) {
            const htmlMessage = buildMessage($portalConfiguration.availability, msg.title);
            availabilityBar.addMessage(MSGKEY_AVAILABILITY_MESSAGE + i, htmlMessage);
        }
    }

    $: if (messageBar) {
        if ($loginTokens?.length) {
            messageBar.removeMessage(MSGKEY_CS_NO_TOKEN);
        } else if ($csAvailableSupported && $portalConfiguration?.support) {
            const supportUrl = new URL('/fragen-antworten/kategorie/erstregistrierung-und-anmeldung/fehler-kein-sicherheitstoken-gefunden', $portalConfiguration.support).toString();
            messageBar.addMessage(MSGKEY_CS_NO_TOKEN, `Falls Ihre beA-Karte nicht erkannt wird, beachten Sie bitte die folgenden <a href='${supportUrl}' target='_blank'>Hinweise</a>.`);
        }
    }

    function buildMessage(link, message) {
        return link ? `<a href="${link}" class="full-bar-link">${message}</a>` : message;
    }

    function addClientSecurityAvailabiltyEventListener() {
        $eventBridge.addEventListener('cs:noClientSecurity', () => {
            messageBar.addMessage(MSGKEY_CS_INACTIVE,
                `Die <a href="/beaportal/#/download">Client Security</a> ist nicht aktiv. Bitte starten Sie die Client Security.`);
        });

        $eventBridge.addEventListener('cs:VersionRead', () => {
            messageBar.removeMessage(MSGKEY_CS_INACTIVE);
        });
    }

    function addClientSecurityVersionEventListener() {
        $eventBridge.addEventListener('kc:unsupportedCsVersion', (event) => {
            const minVersion = event.detail.minVersion;
            const currentVersion = event.detail.currentVersion;
            messageBar.addMessage(MSGKEY_CS_VERSION, `Es wird mindestens die Version ${minVersion} der Client Security benötigt. Ihre Version ${currentVersion} wird nicht mehr unterstützt.`);
        });
    }

    function addClientSecurityGenericErrorEventListener() {
        $eventBridge.addEventListener('cs:Error', () => {
            messageBar.addMessage(MSGKEY_CS_GENERIC_ERROR, "Es ist ein allgemeiner Fehler der Client-Security aufgetreten.");
            setTimeout(() => {
                messageBar.removeMessage(MSGKEY_CS_GENERIC_ERROR);
            }, 5000);
        });
    }

    function addKeycloakMessageEventListener() {
        $eventBridge.addEventListener('kc:message', (event) => {
            if (event.detail.type === 'error' && event.detail.messageCode != 'SSO_LOGIN_EXCEPTION') {
                messageBar.addMessage(MSGKEY_KC_MESSAGE, event.detail.summaryHtml);
            }
        });
    }

    function addClientSecurityEventListener() {
        addClientSecurityAvailabiltyEventListener();
        addClientSecurityVersionEventListener();
        addClientSecurityGenericErrorEventListener();
    }

    function addLoggedOutEventListener() {
        $eventBridge.addEventListener('kc:loggedOut', () => {
            messageBar.addMessage(MSGKEY_BEA_LOGGED_OUT,
                'Sie wurden abgemeldet. Klicken Sie auf Anmelden, um sich erneut anzumelden.');
        });
    }

    onMount(() => {
        addClientSecurityEventListener();
        addKeycloakMessageEventListener();
        addLoggedOutEventListener();
    });
</script>


<div class="top-bar-container">
    <Bar bind:this={messageBar} class="top-bar-message"/>
    <Bar bind:this={operationsBar} class="top-bar-operations"/>
    <Bar bind:this={availabilityBar} class="top-bar-availability"/>
</div>

<style>
    .top-bar-container {
        height: var(--brak-top-bar-container-height);
        width: 100%;
        font-style: italic;
    }

    :global(.top-bar-message) {
        background-color: var(--brak-dark-blue);
        color: var(--brak-greyed-white);
    }

    :global(.top-bar-message > a) {
        color: var(--brak-greyed-white);
    }

    :global(.top-bar-operations) {
        background-color: var(--brak-light-blue);
        color: var(--brak-dark-blue);
    }

    :global(.top-bar-availability) {
        background-color: var(--brak-red);
        color: var(--brak-white);
    }
</style>